import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocalPath } from "../hooks"
import DefaultImage from '../images/default-image.png';
function Seo({
    description,
    title,
    meta = null,
    slug = null,
    lang,
    dynamicSeoImage = null,
    canonicalSlug = null,
    schema = [],
    noIndex = false,
    home = false
}) {
    const { site } = useStaticQuery(
        graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
    )
    const canonicalSlugLocalized = useLocalPath(canonicalSlug)
    const localeSlug = useLocalPath(slug)
    const siteUrl = process.env.URL || 'http://localhost:8000/'
    let seoImage = dynamicSeoImage?.file?.url
    const metaDescription = description || site.siteMetadata.description
    const defaultTitle = site.siteMetadata?.title
    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
            meta={[
                {
                    name: `market`,
                    content: lang
                },
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    property: `og:image`,
                    content: `${seoImage ? `https:${seoImage}` : DefaultImage}`
                },
                {
                    property: `og:image:secure_url`,
                    content: `${seoImage && `https://secure.${seoImage.substr(2)}`}`
                },
                {
                    property: `og:image:type`,
                    content: `image/jpeg`
                },
                {
                    property: `og:image:width`,
                    content: `400`
                },
                {
                    property: `og:image:height`,
                    content: `300`
                },
                {
                    property: `og:image:alt`,
                    content: `Lipton Teas and Infusions`
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata?.author || ``,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
            ].concat(meta)}
        >
            {
                home
                    ? <meta name="google-site-verification" content="V_eN8fQiOCLnDfDuXs8c97ERV-9eC6t1Nk97xBOSYLw" />
                    : null
            }
            {
                noIndex
                    ? <meta name="robots" content="noindex, follow" />
                    : <div></div>
            }
            <link rel="canonical" href={canonicalSlug ? `${siteUrl}${canonicalSlugLocalized}` : `${siteUrl}${localeSlug}`} />
            {
                (schema && schema.length > 0)
                    ? schema.map((schema, index) => (<script key={index} type='application/ld+json'>{JSON.stringify(schema)}</script>))
                    : null
            }
        </Helmet>
    )
}

Seo.defaultProps = {
    lang: `ja`,
    meta: [],
    description: ``,
}

Seo.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default Seo
